export default class Form {

	constructor()
	{
		Form.select();
		Form.newsletter_email();
		Form.form_animation();
	}

	static select()
	{
		$( 'select' ).parent().not( '.formSelect' ).children( 'select' ).wrap( '<div class="formSelect"></div>' );
	}

	/* Newsletter
	/* ============================================= */
	static newsletter_email()
	{
		if ( $( '#field_newsletter-email' ).length > 0 ) {
			let email = $POST_EMAIL;
			$( '#field_newsletter-email' ).attr( 'value', email );
		}
	}

	/* Form animation
    /* ============================================= */
	static form_animation()
	{
		const $input = $(".formGroup--text input, .formGroup--textarea textarea, .formGroup--select select, .formGroup--phone input, .formGroup--number input, .formGroup--email input, #newsletter-field, .wpSearchFormItem--input");

		$input.each(function () {
			if ( $(this).val().length != 0 ) {
				$(this).closest('.frm_form_field').find('label').addClass("label-active");
			}
		});

		$input.focusin(function() {
			$(this).closest('.frm_form_field').find('label').addClass("label-active");
		});

		$input.focusout(function() {
			if ( $(this).val().length == 0 ) {
				$(this).closest('.frm_form_field').find('label').removeClass("label-active");
			}
		});
	}
}